import React from 'react';
import OrderOfficeReinigung from './Components/OrderOfficeReinigung';
const App: React.FunctionComponent<{}> = (props) => {
  return (
    <OrderOfficeReinigung /> 
  );
}

export default App;
